export default "__VITE_ASSET__CkTh2VM$__"